/* import __COLOCATED_TEMPLATE__ from './slack.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { get } from 'embercom/lib/ajax';
import { dropTask } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';

interface Args {
  model: any;
}

export default class Slack extends Component<Args> {
  @service declare appService: any;
  @service declare redirectService: any;

  @dropTask
  *authenticate(): TaskGenerator<void> {
    let response = yield get(`/ember/slack/v2/integrations/install`, {
      app_id: this.appService.app.id,
      admin_id: this.appService.app.currentAdmin.id,
    });
    this.redirectService.redirect(response.url);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Slack': typeof Slack;
    'new-settings/channels/slack': typeof Slack;
  }
}
